// Import base react and redux components
import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import DOMify from 'react-domify'

// Import page components
import Modal from 'react-modal'
import ComponentPageDom from 'elements/ComponentPageDom'
import TableList from './components/tableList'
import TaskForm from './components/taskForm'
import ManageColorsForm from './components/manageColorsForm'
import ManageColorPickerForm from './components/manageColorPickerForm'
import NotificationContent from './components/notificationContent'
import TaskCreator from '../taskCreator'

// Import page element components
import {Table, Thead, Th, Tr, Td, collapseTd} from 'components/reactable'

// Import libraries
import moment from 'moment'
import i18n from 'lib/i18n'
import c from 'state/constants'

// Import helper functions
import {dateFormatter} from 'lib/helpers'
import {map} from 'lodash/collection'
import underscore from 'underscore'

// Import styles and object styles for modals
import styles from './taskList.scss'
import rt from '../reactable.scss'

// Import actions to handle store changes
import {
	taskModuleListGet,taskModuleListGetDefaultColors,taskModuleListGetUserColors,taskModuleFilter,
	taskModuleModalToggle,taskModuleFormCleanAction,taskModuleFormEditSetAction,taskModuleModalNotificationSet,
	taskModuleFormCreateTask,taskModuleFormUpdateTask,taskModuleTaskDelete,
	taskModuleFormCreateTaskColor,taskModuleFormUpdateTaskColor,taskModuleTaskColorDelete,taskModuleTaskColorReset,
	taskModuleItemCheck,taskModuleItemCheckAllVisible,
	resetStaffList,sendTaskToUser,setTaskReaded,taskCreatorModalToggle,
	taskCreatorGenerateWithRelations
} from 'state/actions'

/**
 * Here you can define default constants for the component
 */
const _ = i18n('agenda2') // Setup translation group to agenda2

const manageModalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
		padding: '0px',
		paddingBottom: '0.5em'
    },
}

/**
 * Redux connect
 *
 * Here we get all the required data from store and populate component properties
 */
@connect(({
		taskList: {
			items, filterStatusValue, filterColorValue,
			modals, notification,
			colorsList,
			manageTask, manageColors, manageColorPicker
		},
		inbox: {staff},
		app: {userId}
	}) => ({
		items, filterStatusValue, filterColorValue,
		modals, notification,
		colorsList,
		manageTask, manageColors, manageColorPicker,
		staff, userId
	}),{
		taskModuleListGet,taskModuleListGetDefaultColors,taskModuleListGetUserColors, taskModuleFilter,
		taskModuleModalToggle,taskModuleFormCleanAction,taskModuleFormEditSetAction, taskModuleModalNotificationSet,
		taskModuleFormCreateTask,taskModuleFormUpdateTask,taskModuleTaskDelete,
		taskModuleFormCreateTaskColor, taskModuleFormUpdateTaskColor,taskModuleTaskColorDelete,taskModuleTaskColorReset,
		taskModuleItemCheck,taskModuleItemCheckAllVisible,
		resetStaffList,sendTaskToUser,setTaskReaded,taskCreatorModalToggle,
		taskCreatorGenerateWithRelations
	}
)
export default class TaskList extends Component {
	/**
	 * Set the required property types for the component
	 */
	static propTypes = {
		taskModuleListGet:React.PropTypes.func.isRequired,
		taskModuleListGetDefaultColors: React.PropTypes.func.isRequired,
		taskModuleListGetUserColors: React.PropTypes.func.isRequired,
		taskModuleFilter: React.PropTypes.func.isRequired,
		taskModuleModalToggle: React.PropTypes.func.isRequired,
		taskModuleFormCleanAction: React.PropTypes.func.isRequired,
		taskModuleFormEditSetAction: React.PropTypes.func.isRequired,
		taskModuleModalNotificationSet: React.PropTypes.func.isRequired,
		taskModuleFormCreateTask: React.PropTypes.func.isRequired,
		taskModuleFormUpdateTask: React.PropTypes.func.isRequired,
		taskModuleTaskDelete: React.PropTypes.func.isRequired,
		taskModuleFormCreateTaskColor: React.PropTypes.func.isRequired,
		taskModuleFormUpdateTaskColor: React.PropTypes.func.isRequired,
		taskModuleTaskColorDelete: React.PropTypes.func.isRequired,
		taskModuleTaskColorReset: React.PropTypes.func.isRequired,
		taskModuleItemCheck: React.PropTypes.func.isRequired,
		taskModuleItemCheckAllVisible: React.PropTypes.func.isRequired,
        taskCreatorModalToggle: React.PropTypes.func.isRequired
	}

	constructor(props) {
		super(props)
		this.state = {
			staffList: [],
			itemsList: [],
		}
	}

	/**
	 * Component will mount
	 */
	componentWillMount() {
		const { taskModuleListGet, taskModuleListGetDefaultColors, taskModuleListGetUserColors } = this.props

		taskModuleListGetDefaultColors()
		taskModuleListGetUserColors()
		taskModuleListGet()
	}

	/**
	 * Handle todo modal toggle
	 *
	 * @param string $modalType
	 */
	handleModalToggle(modalType) {
		const { taskModuleModalToggle } = this.props
		taskModuleModalToggle(modalType)
	}

	/**
	 * Handle notification type set action dispatcher
	 */
	handleModalNotificationTypeSet(notificationType, itemId = null) {
		const { taskModuleModalNotificationSet } = this.props
		taskModuleModalNotificationSet(notificationType, itemId)
	}

	/**
	 * Handle create task action dispatcher
	 */
	handleCreateTask(task) {
		const { taskModuleFormCreateTask } = this.props
		taskModuleFormCreateTask(task)
	}

	/**
	 * Handle update task action dispatcher
	 */
	handleUpdateTask(task) {
		const { taskModuleFormUpdateTask } = this.props
		taskModuleFormUpdateTask(task)
	}

	/**
	 * Handle delete tasks that are selected
	 */
	handleDeleteTask(tasks) {
		const { taskModuleTaskDelete } = this.props
		taskModuleTaskDelete(tasks)
	}

    /**
	 * Handle create task color action dispatcher
	 */
	handleCreateTaskColor(taskColor) {
		const { taskModuleFormCreateTaskColor} = this.props
		taskModuleFormCreateTaskColor(taskColor)
	}

	/**
	 * Handle create task color action dispatcher
	 */
	handleUpdateTaskColor(taskColor) {
		const { taskModuleFormUpdateTaskColor} = this.props
		taskModuleFormUpdateTaskColor(taskColor)
	}

	/**
	 * Handles delete task color action dispatcher
	 */
	handleDeleteTaskColor(taskColorId) {
		const { taskModuleTaskColorDelete } = this.props
		taskModuleTaskColorDelete(taskColorId)
	}

	/**
	 * Handles reset task color action dispatcher
	 */
	handleResetTaskcolor() {
		const { taskModuleTaskColorReset } = this.props
		taskModuleTaskColorReset()
	}

	/**
	 * Handle form cleaning
	 * This sets the requested form state to default value
	 */
	handleFormClean(formType) {
		const { taskModuleFormCleanAction } = this.props
		taskModuleFormCleanAction(formType);
	}

	/**
	 * Handle set edit form
	 * This sets the form state to edit mode based on requested parameters
	 */
	handleSetEditForm(formType, entityId) {
		const { taskModuleFormEditSetAction } = this.props
		taskModuleFormEditSetAction(formType, entityId)
	}

	/**
	 * Handle filter action
	 */
	handleFilter(filterStatusValue, filterColorValue) {
		const { taskModuleFilter } = this.props
		taskModuleFilter(filterStatusValue, filterColorValue)
	}

	/**
	 * Handles checkbox check for table item
	 */
	handleCheckTableItem(event, itemId)	{
		const { taskModuleItemCheck } = this.props

		event.stopPropagation();
		taskModuleItemCheck(itemId)
	}

	/**
	 * Handles check all action for table items checkboxes
	 */
	handleCheckAllVisible(visibleItems) {
		const { taskModuleItemCheckAllVisible } = this.props
		taskModuleItemCheckAllVisible(visibleItems)
	}

	/**
	 * Set the modal state when opening modal
	 */
	setSendTaskModalState() {
		const { staff,items } = this.props
		let stateItems = []

		items.map((value,key) => {
			stateItems[key] = {...value}
		})

		stateItems = stateItems.filter(item => item.checked)

		this.setState({staffList: staff, itemsList: stateItems})
	}

	/**
	 * Clean send task component state
	 */
	cleanSendTaskModalState() {
		const { resetStaffList } = this.props

		this.setState({
			staffList: [],
			itemsList: []
		})

		resetStaffList()
	}

	/**
	 * Toggle the user selection based on user id
	 * this function is used on send task modal user list click event
	 *
	 * @param {int} userId the selection user id
	 */
	toggleUserSelection(userId) {
		let {staffList} = this.state

		staffList.map((value, key) => {
			if(value.userId == userId) {
				value.selected = !value.selected
			}

			staffList[key] = value
		})

		this.setState({staffList: staffList})
	}

	handleSendTask() {
		const { sendTaskToUser } = this.props
		const { staffList, itemsList } = this.state

		sendTaskToUser({
			items: itemsList,
			users: staffList,
		})
    }

     /**
	 * Handles ticket title changes based on input value
	 *
	 * @param {object} ev the input field object data
	 * @param {int} itemKey the array key of the current edited item
	 */
    handleTaskTitleChange(itemKey,ev) {
        const itemsList = this.state.itemsList
		const items = []

		itemsList.map((value,key) => {
			items[key] = value

			if(items[itemKey]) {
				items[itemKey].title = ev.target.value
			}
		})

		this.setState({itemsList: items})
    }

    /**
	 * Handles ticket details changes based on input value
	 *
	 * @param {object} ev the input field object data
	 * @param {int} itemKey the array key of the current edited item
	 */
    handleTaskDetailChange(itemKey, ev) {
        const itemsList = this.state.itemsList
		const items = []

		itemsList.map((value,key) => {
			items[key] = value

			if(items[itemKey]) {
				items[itemKey].description = ev.target.value
			}
		})

		this.setState({itemsList: items})
    }

	/**
	 * Handles task date changes based on datepicker value
	 *
	 * @param {string} ev the value of the datepicker
	 * @param {int} itemKey the array key of the current edited item
	 */
	handleTaskDateChange(ev, itemKey) {
		const itemsList = this.state.itemsList
		const items = []

		itemsList.map((value,key) => {
			items[key] = value

			if(items[itemKey]) {
				items[itemKey].endDate = ev
			}
		})

		this.setState({itemsList: items})
	}

    handleSetStatusReaded(task) {
        const { setTaskReaded } = this.props
        setTaskReaded(task)
    }

    /**
     * Converts the task items to task `shape` objects to be readable by the taskCreator component
     * @param {array} items the list of data to be converted
     * @return {array} the task `shape` objects generated data
     */
    generateTaskCreatorItems = ( items ) => {
        let convertedItems = []
        let selectedItems = items.filter(item => item.checked)

        if( selectedItems.length > 0 ) {
            selectedItems.map((value, key) => {
                let ticketDocuments = null
                let ticketDoctype = null
                let ticketReferral = null
                let colorCode = null

                if( value.ticketDocuments && value.ticketDocuments !== undefined ) {
                    ticketDocuments = value.ticketDocuments
                }

                if( value.ticketDoctype && value.ticketDoctype !== undefined ) {
                    ticketDoctype = value.ticketDoctype
                }

                if( value.ticketReferral && value.ticketReferral !== undefined ) {
                    ticketReferral = value.ticketReferral
                }

                if( value.colorCode && value.colorCode !== undefined ) {
                    colorCode = value.colorCode
                }

                convertedItems.push({
                    title: value.title,
                    description: value.description,
                    endDate: value.endDate,
                    taskRelation: value.id,
                    ticketDocuments: ticketDocuments,
                    ticketDoctype: ticketDoctype,
                    ticketReferral: ticketReferral,
                    colorCode: colorCode
                })
            })
        }

        return convertedItems
    }

	/**
	 * Render the component Html
	 */
	render() {
		const {
			items, filterStatusValue, filterColorValue,
			modals,notification,
			colorsList,
			manageTask, manageColors, manageColorPicker,
			staff, taskCreatorModalToggle, userId
		} = this.props

		return (
			<ComponentPageDom
				title={_('pageTitle')}
				subtitle={_('subtitle')}
			>
				<div className={styles.results}>
					<TableList
						items={items}
						filterStatusValue={filterStatusValue}
						filterColorValue={filterColorValue}
						toggleModal={this.handleModalToggle.bind(this)}
						setEditAction={this.handleSetEditForm.bind(this)}
						filterAction={this.handleFilter.bind(this)}
						colorOptions={colorsList}
						checkTableItemAction={this.handleCheckTableItem.bind(this)}
						checkTableAllItemsAction={this.handleCheckAllVisible.bind(this)}
						setNotificationTypeAction={this.handleModalNotificationTypeSet.bind(this)}
                        setSendTaskModalState={taskCreatorModalToggle}
						setTaskReaded={this.handleSetStatusReaded.bind(this)}
					/>
				</div>
				<Modal
					isOpen={modals.manageTask}
					style={manageModalStyles}
                    contentLabel={""}
				>
					<TaskForm
						taskList={items}
						formState={manageTask}
						selectColorOptions={colorsList}
						toggleModal={this.handleModalToggle.bind(this)}
						createTaskAction={this.handleCreateTask.bind(this)}
						editTaskAction={this.handleUpdateTask.bind(this)}
						formCleanAction={this.handleFormClean.bind(this)}
						setNotificationTypeAction={this.handleModalNotificationTypeSet.bind(this)}
						staff={staff}
						taskCreatorGenerateWithRelations={this.props.taskCreatorGenerateWithRelations}
						userId={userId}
					/>
				</Modal>
				<Modal
					isOpen={modals.manageColors}
					style={manageModalStyles}
                    contentLabel={""}
				>
					<ManageColorsForm
						userColors={colorsList.userColors}
						toggleModal={this.handleModalToggle.bind(this)}
						setEditAction={this.handleSetEditForm.bind(this)}
						setNotificationTypeAction={this.handleModalNotificationTypeSet.bind(this)}
					/>
				</Modal>
				<Modal
					isOpen={modals.manageColorPicker}
					style={manageModalStyles}
                    contentLabel={""}
				>
					<ManageColorPickerForm
						formState={manageColorPicker}
						createAction={this.handleCreateTaskColor.bind(this)}
						updateAction={this.handleUpdateTaskColor.bind(this)}
						toggleModal={this.handleModalToggle.bind(this)}
						formCleanAction={this.handleFormClean.bind(this)}
						userColors={colorsList.userColors}
					/>
				</Modal>
				<Modal
					isOpen={modals.notification}
					style={manageModalStyles}
                    contentLabel={""}
				>
					<NotificationContent
						items={items}
						deleteTaskAction={this.handleDeleteTask.bind(this)}
						notificationType={notification.type}
						notificationItemId={notification.itemId}
						toggleModal={this.handleModalToggle.bind(this)}
						resetTaskColorsAction={this.handleResetTaskcolor.bind(this)}
						deleteColorAction={this.handleDeleteTaskColor.bind(this)}
					/>
				</Modal>
                <TaskCreator
                    modalTitle={'taskTaskCreatorModalTitle'}
                    taskItems={this.generateTaskCreatorItems(items)}
                    staffItems={staff}
                    convertionType="task"
                />
			</ComponentPageDom>
		)
	}
}



// WEBPACK FOOTER //
// ./components/taskList/index.jsx